import React, { useContext, useEffect, useRef, useState } from 'react'
import { HandLandmarker, FilesetResolver } from "@mediapipe/tasks-vision";
import mediapipe_hands from '../assets/models/hand_landmarker.task'

const HandsProviderContext = React.createContext();
export function useHandsProvider() {
    return useContext(HandsProviderContext)
}

export function HandsProvider({ children }) {

    const handsModel = useRef(null);
    const [ statusHands, setStatusHands ] = useState(false);
    const statusHandsRef = useRef(statusHands);
    const handsDataRef = useRef(null);
    const bufferHandsDataRef = useRef([]);

    const initializeHands = async () => {
        console.log("🚀 ~ Hands ~ initializeHands:", initializeHands)
        handsModel.current = await HandLandmarker.createFromOptions(await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"), {
            baseOptions: {
              modelAssetPath: mediapipe_hands,
              delegate: "GPU"
            },
            numHands: 2,
            runningMode: 'IMAGE'
        });
        statusHandsRef.current = true;
        console.log("🚀 ~ Segmenter ~ handsModel.current:", handsModel.current)
    };
    
    useEffect(() => {
        if (statusHands){
            initializeHands();
        }
        else{
            handsModel.current = null
            statusHandsRef.current = false;
            handsDataRef.current = null
            bufferHandsDataRef.current = []
        }
    }, [statusHands])

    async function applyHandsOnCanvas(streamImageBitmapRef, streamCanvasRef, streamContextRef){
        if (statusHandsRef.current){
            streamImageBitmapRef.current = await createImageBitmap(streamCanvasRef.current);
            handsDataRef.current = await handsModel.current.detect(streamImageBitmapRef.current);
            if (handsDataRef.current!== null) {
                // console.log("🚀 ~ MediapipeHolisticProvider ~ applyHandsOnCanvas ~ handsDataRef.current:", handsDataRef.current)
                // bufferHandsDataRef.current = [...bufferHandsDataRef.current, handsDataRef.current]
                bufferHandsDataRef.current = [...bufferHandsDataRef.current, handsDataRef.current].slice(-1000);
            } 
        }else{
            console.log("🚀 ~ MediapipeHolisticProvider ~ applyHandsOnCanvas STEP EEROR  -- NO INICALIZADO:")
        }
        return Promise.resolve();
    }


    /* Exported values */
    const value = {
        statusHands,
        setStatusHands,
        statusHandsRef,
        applyHandsOnCanvas,
        handsDataRef,
        bufferHandsDataRef
    }

    return (
        <HandsProviderContext.Provider value={value}>
            {children}
        </HandsProviderContext.Provider>
    )
}